import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsbYesNoComponent } from './csb-yes-no.component';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CSBCoreModule } from '../../csb-core/csb-core.module';

@NgModule({
    declarations: [CsbYesNoComponent],
    imports: [CommonModule, FormsModule, MatButtonToggleModule, CSBCoreModule],
    exports: [CsbYesNoComponent],
})
export class CsbYesNoModule {}
